import { action } from 'satcheljs';
import type { WindowKey } from 'owa-bizchat-types';
import type { MailboxInfo } from 'owa-client-types';
import type { CopilotDrawerContent } from '../types/CopilotDrawerContent';

export interface OnCopilotChatDrawerClosedMessage {
    // Whether the action is triggered programmatically or by user interaction.
    isProgrammatic: boolean;
    // The window key identifying which window the drawer was closed in.
    windowKey: WindowKey;
    // Account whose pane closed. Forwarded to close telemetry; optional because
    // not every (future) caller is guaranteed to have it resolved.
    mailboxInfo?: MailboxInfo;
    // Milliseconds the pane was open before closing. Forwarded to close telemetry.
    timeSinceOpened?: number;
    // What this drawer cycle was opened to show. Listeners should skip chat-pane telemetry
    // unless it is 'chat'.
    openedContent?: CopilotDrawerContent;
}
export const onCopilotChatDrawerClosed: (
    isProgrammatic: boolean,
    windowKey: WindowKey,
    mailboxInfo?: MailboxInfo,
    timeSinceOpened?: number,
    openedContent?: CopilotDrawerContent
) => OnCopilotChatDrawerClosedMessage = action(
    'onCopilotChatDrawerClosed',
    (
        isProgrammatic: boolean,
        windowKey: WindowKey,
        mailboxInfo?: MailboxInfo,
        timeSinceOpened?: number,
        openedContent?: CopilotDrawerContent
    ): OnCopilotChatDrawerClosedMessage => ({
        isProgrammatic,
        windowKey,
        mailboxInfo,
        timeSinceOpened,
        openedContent,
    })
);
